import Section from "../../components/Section/Section.js";
import {talkSection} from "../../portfolio";

export default function Talks() {
  return <Section sectionData={talkSection} id="talks" />;
}
